import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/navigation/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import SamplePostsSection from './components/SamplePostsSection';
import TrustSignalsSection from './components/TrustSignalsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>OnlyCuts - Safe Space for Emotional Expression</title>
        <meta 
          name="description" 
          content="Share your emotional struggles anonymously and receive supportive reactions in a judgment-free environment. OnlyCuts is where emotional cuts find healing." 
        />
        <meta name="keywords" content="emotional support, anonymous posting, peer support, mental health, safe space" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-[60px]">
          <HeroSection />
          <FeaturesSection />
          <HowItWorksSection />
          <SamplePostsSection />
          <TrustSignalsSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default LandingPage;